
// Dependancies
import wpapi from './wpapi'

// Modules
import listings from './listings'
import listingsFilter from './listings.filter'
import listingsResults from './listings.results'

const self = {

  savedSearchName : e => {
    e.preventDefault()
    if ( listings.elms.savedSearchInput.length === 0 ) return false
    console.log('saving with params', listings.activeFilters, Object.keys(listings.activeFilters).length)

    let searchParams
    let activeSearchPanel = document.querySelector('#listings-picker .tab.active').getAttribute('rel');

    if ( activeSearchPanel === 'focus-search' ) {
      let streetNames = []
	    const addressFields = Array.from(document.querySelectorAll('input[name="street_name"]'))

      addressFields.map( field => {
        if ( field.value.length > 0 ) streetNames.push(field.value)
      })

	    searchParams = { type : 'address', address : streetNames.join(',') }
    }

    return wpapi.saveSearchDataFor({
      userID: listings.userID,
      searchParams: searchParams || listings.activeFilters,
      searchName:  listings.elms.savedSearchInput.value
    })
  },

  saveAddressSearch : e => {
	  console.log('saveAddressSearch');
	  var a = document.querySelectorAll('input[name="street_name"]');
	  var addr = [];
	  for (var i = 0; i < a.length; i++) {
		  console.log(a[i].value);
		  addr.push(a[i].value);
	  }
	  var addr_string = addr.join(',');
	  console.log(addr_string);
	  return wpapi.saveSearchDataFor({
	      userID: listings.userID,
	      searchParams: {address: addr_string},
	      searchName:  addr_string
    })
  },

  showSavedSearchOverlay : e => {
    listings.elms.savedSearchOverlay.className = "show"

    setTimeout( () => listings.elms.savedSearchOverlay.setAttribute('rel', 'input'), 250)
    setTimeout( () => listings.elms.savedSearchInput.focus(), 500)
  },

  closeSearchOverlay : ({delay = 0}) => {
    const delayDouble = (delay > 0) ? delay * 2 : 1000

    setTimeout( () => {
      listings.elms.savedSearchOverlay.removeAttribute('rel')
      listings.elms.savedSearchOverlay.classList.add("fade")
      listings.elms.savedSearchInput.value = ""
    }, delay)

    setTimeout( () => {
      listings.elms.savedSearchOverlay.removeAttribute("class")
    }, delayDouble)
  },

  setFiltersFromSearchParams : () => {
    let activeFilterObj = {}
    const params = location.search.substring(1).split('&')
    const isAddress = params[0].search('address') !== -1

    // Show the correct tab on load (focus search or custom search)
    if ( isAddress ) {
      listings.elms.pickerTabsNav.querySelector('button[rel="focus-search"]').click()
    } else {
      listings.elms.pickerTabsNav.querySelector('button[rel="custom-search"]').click()
    }

    // Loop through params to update the UI and build the active filter obj
    params.forEach( param => {
      let filterElement
      const paramArr = param.split('=')
      const prop = paramArr[0]
      const val = paramArr[1].replace('%20', ' ')
      const propSelector = `ul[data-type="${prop}"]`
      const valSelector = `li[data-val="${val}"]`

      if ( prop.search("dwelling_type") !== -1 || prop.search("home_style") !== -1 ) {

        activeFilterObj[prop] = []

        val.split(",").map( hoodVal => {
          const selector = `li[data-type="${prop}"][data-val="${hoodVal}"]`
          filterElement = listings.elms.customSearchTab.querySelector(selector)
          filterElement.classList.add('selected')
          activeFilterObj[prop].push(hoodVal)
        })


      } else if ( prop.search("price") !== -1 ) {

        const priceArr = prop.split('.')
        const key = priceArr[1]

        // Update filter EL
        filterElement = listings.elms.customSearchTab.querySelector(`select[data-type="${priceArr[0]}"][name="${key}"]`)
        filterElement.value = val

        // Set active filter obj
        if (!activeFilterObj.price) activeFilterObj.price = {}
        activeFilterObj.price[key] = val

      } else if ( prop.search("neighbourhood") !== -1 ) {

        // Create a new array for hoods in the active search params obj
        activeFilterObj[prop] = []

        // Split values into array
        // Loop through values and select the appropriate UI element
        // Add value to active filter array
        val.split(",").map( hoodVal => {
          listings.elms.customSearchTab.querySelector(`${propSelector} [data-val="${hoodVal}"]`).classList.add("selected")
          activeFilterObj[prop].push(hoodVal)
        })

      } else if ( prop.search("address") !== -1 ) {

        const addrInputs = Array.from(document.querySelectorAll('input[name="street_name"]'))
        val.split(',').map(( addr, i ) => addrInputs[i].value = decodeURI(addr) )

      } else {

        // Update filter EL
        filterElement = listings.elms.customSearchTab.querySelector(`${propSelector} ${valSelector}`)
        filterElement.classList.add('selected')

        // Set active filter obj
        activeFilterObj[prop] = val

      }
    })

    // Set the filters and filter the listings
    listings.activeFilters = activeFilterObj
    listingsFilter.shouldSaveSearchButtonBeDisabled()

    // Click the focus search or custom search buttons
    if ( isAddress ) {
      listings.elms.addressSubmit.click()
    } else {
      listings.elms.btnFilterResults.click()
    }

  }

}

export default self
